
document.addEventListener("DOMContentLoaded", function () {
    var loadMoreBtn = document.getElementById("loadMoreBtn");
    var items = document.querySelectorAll(".collapsible-item.hidden");

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener("click", function () {
            items.forEach(function (item) {
                item.classList.toggle("hidden");
            });
            var isExpanded = !items[0].classList.contains("hidden");
            loadMoreBtn.innerHTML = isExpanded ? 'Load Less<span></span>' : 'Load More<span></span>';
            loadMoreBtn.classList.toggle("active");
        });
    }
});


